/**
 * SEO 全局配置
 *
 * 页面与 meta 均使用通用婚恋表述，强调严肃婚恋与共同价值观，
 * 不使用特定宗教称谓。
 *
 * 上线前请将 SITE_URL 改为正式备案域名。
 */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://www.example.com";

/** 网站对外展示品牌名（页面可见） */
export const SITE_NAME = "AI婚恋智能体生态平台";

export const SITE_TAGLINE = "认识自己 · 找到适合的人 · 成长为更好的伴侣";

/**
 * 搜索引擎专用关键词（meta keywords）
 */
export const SEARCH_KEYWORDS = [
  "找对象",
  "脱单",
  "同城脱单",
  "婚恋交友",
  "相亲网站",
  "同城相亲",
  "征婚",
  "严肃婚恋",
  "以结婚为目的的交友",
  "共同价值观",
  "价值观匹配",
  "免费相亲",
  "在线相亲",
  "婚恋咨询师",
  "婚姻咨询师",
  "免费婚恋陪伴",
  "婚前辅导",
  "恋爱指导",
  "婚姻咨询",
  "婚姻修复",
  "夫妻关系",
  "情感咨询",
  "婚恋咨询",
  "AI智能匹配",
  "AI婚恋",
  "AI相亲",
  "性格测评找对象",
  "婚恋测评",
  "30岁找对象",
  "离异再婚",
  "二婚找对象",
].join(",");

/**
 * 搜索结果摘要（meta description）
 */
export const SEARCH_META_DESCRIPTION =
  "AI婚恋平台专注严肃婚恋与同城找对象，强调共同价值观与长期关系，配备专业咨询师（非传统红娘），前期免费一对一陪伴，从相识、恋爱到结婚全程辅导。支持AI测评、智能匹配、婚姻咨询，覆盖全国主要城市。";

/** 分享链接时的中性描述（微信等） */
export const PUBLIC_OG_DESCRIPTION =
  "AI婚恋平台：找对象、婚恋匹配、婚姻咨询。专业咨询师免费陪伴，AI测评与智能推荐，从相识到婚姻全程服务。";

export const SEO_PAGES = {
  home: {
    title: "中国AI婚恋智能体生态平台 - AI咨询师_智能匹配_婚恋成长",
    metaDescription:
      "中国AI婚恋智能体生态平台：AI咨询师帮助你认识自己，生成婚恋画像，深度匹配适合的人，并陪伴成长为更好的伴侣。",
    ogDescription: PUBLIC_OG_DESCRIPTION,
    keywords: SEARCH_KEYWORDS,
    path: "/",
  },
  discover: {
    title: "同城找对象_严肃相亲推荐 - AI婚恋平台",
    metaDescription:
      "寻找合适的结婚对象，认证会员优先、最近活跃靠前。按共同价值观与资料匹配异性，专业咨询师免费陪伴，支持按城市、年龄、学历等筛选。",
    ogDescription:
      "同城找对象与相亲推荐，AI匹配 + 咨询师陪伴，按条件筛选合适的对象。",
    keywords: SEARCH_KEYWORDS,
    path: "/discover",
  },
  consultants: {
    title: "婚恋咨询师_免费陪伴到结婚 - AI婚恋平台",
    metaDescription:
      "平台专业婚恋咨询师，区别于传统红娘介绍，提供前期免费长期陪伴：从找对象、交往沟通到谈婚论嫁全程辅导，另有婚姻修复与关系咨询服务。",
    ogDescription:
      "专业婚恋咨询师，前期免费陪伴，从找对象到结婚全程辅导。",
    keywords: SEARCH_KEYWORDS,
    path: "/consultants",
  },
  register: {
    title: "免费注册_找对象婚恋交友 - AI婚恋平台",
    metaDescription:
      "免费注册会员，完善资料后即可智能匹配对象并获得咨询师陪伴；已婚用户可进入婚姻咨询与关系测评服务。",
    ogDescription: "免费注册，开启找对象、婚恋匹配与咨询服务。",
    keywords: SEARCH_KEYWORDS,
    path: "/register",
  },
  registerConsultant: {
    title: "咨询师入驻 - AI婚恋平台",
    metaDescription:
      "欢迎具备婚恋辅导、心理咨询经验的专业咨询师入驻，为用户提供找对象与婚恋关系陪伴服务。",
    ogDescription: "专业咨询师入驻，参与婚恋陪伴与咨询服务。",
    keywords: "婚恋咨询师,咨询师入驻,情感咨询,婚姻辅导",
    path: "/registerConsultant",
  },
};

export const INDEXABLE_ROUTES = [
  "/",
  "/discover",
  "/consultants",
  "/register",
  "/registerConsultants",
  "/login",
  "/topic",
  "/book-club",
  "/events",
  "/courses",
  "/moments",
  "/love-map",
  "/love-map/couple",
  "/ai-love-card",
];

export const NOINDEX_ROUTE_PREFIXES = [
  "/center",
  "/admin",
  "/chat",
  "/profile",
  "/consultant/",
  "/consultant-chat",
  "/user/",
  "/inbox",
  "/friends",
  "/match",
  "/result",
  "/questionnaire",
  "/ai/relationship-map",
  "/ai/hub",
  "/ai/companion",
  "/ai/behavior-profile",
  "/ai/relationship-memory",
  "/ai/relationship-train",
  "/reading/checkin",
];

/** 供 JSON-LD 使用的检索关键词 */
export const SEARCH_TOPICS = [
  "找对象",
  "严肃婚恋",
  "共同价值观",
  "婚恋交友",
  "脱单相亲",
  "相亲",
  "婚姻咨询",
  "婚姻修复",
  "婚恋咨询师",
  "AI智能匹配",
  "AI婚恋",
];
